import React from 'react';
import { Timeline } from '@mui/lab';
import { QUICK_GUIDE } from 'app/utils/constants';
import ActivitiesItem from './QuickGuideItem';

const QuickGuideList = () => {
  return (
    <Timeline sx={{ m: 0, p: theme => theme.spacing(0, 3) }}>
      {QUICK_GUIDE.map(item => {
        return (
        <ActivitiesItem item={item} key={item.title + item.subTitle} />
      )})}
    </Timeline>
  );
};

export default QuickGuideList;
